import styled from 'styled-components';

import { Box, Image } from 'components/library';

import { color } from 'theme/selectors';
import mediaQueries from 'theme/mediaQueries';

export const AuthContainer = styled.div`
    width: 100vw;
    min-height: calc(100vh - 56px);
    display: flex;
    flex-direction: row;
    align-items: start;

    ${mediaQueries.tablet} {
        align-items: center;
    }

    ${mediaQueries.tabletLandscape} {
        align-items: stretch;
    }
`;

export const AuthForm = styled.div`
    position: relative;
    width: calc(400px + 16px * 2);
    margin: 0 auto;
    padding: 32px 0;

    ${mediaQueries.tabletLandscape} {
        padding-top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: calc(340px + 16px * 2);
    }
`;

export const AuthImageBox = styled(Box)`
    display: none;
    justify-content: center;
    align-items: center;
    width: 50%;
    background: ${color('surface-default')};

    ${mediaQueries.tabletLandscape} {
        display: flex;
    }
`;

export const AuthImage = styled(Image)`
    height: 500px !important;
`;
